import {useQuery} from '@tanstack/react-query';
import {type VerificationSettings} from '@guestapp/sdk';
import {useChekinSDK} from 'context/ChekinSDK/useChekinSDK';
import {useGuestGroup} from 'hooks';
import {QUERY_CACHE_KEYS} from 'utils/constants';

export function useVerificationSettings(housingId?: string) {
  const {getSettings} = useChekinSDK();
  const {guestGroup} = useGuestGroup();

  const isLeadGuest = !guestGroup?.added_number_of_guests;

  const {data, isLoading} = useQuery<VerificationSettings[] | undefined>({
    queryKey: [QUERY_CACHE_KEYS.verificationSettings, housingId],
    queryFn: () => getSettings(housingId!),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: Boolean(housingId && isLeadGuest),
  });

  const isEmailEnabled = data?.[0]?.require_email_otp;
  const isPhoneEnabled = data?.[0]?.require_phone_otp;
  const isVerified = !!guestGroup?.is_leader_contact_verified;

  const isNeedVerification = Boolean(
    isLeadGuest && !isVerified && !!(isEmailEnabled || isPhoneEnabled),
  );

  if (!isNeedVerification) {
    return {
      isEmailEnabled: false,
      isPhoneEnabled: false,
      isLoading: false,
      isNeedVerification: false,
    };
  }

  return {
    isEmailEnabled,
    isPhoneEnabled,
    isLoading,
    isNeedVerification,
  };
}
